// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useState } from "react";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Wrecksite from "pages/LandingPages/Locations/WestCoast/sections/wrecksite";
import Reefdives from "pages/LandingPages/Locations/WestCoast/sections/reefdives";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function Introduction() {
  const [activeSection, setActiveSection] = useState("wreck");
  return (
    <MKBox component="section" py={8}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={50} md={32}>
            <Grid container justifyContent="flex-start">
              <MKTypography variant="body1" mt={1} mb={0}>
                The West Coast of Sri Lanka transforms into a diver’s paradise from November to
                April, when the seas are calm and crystal clear. This season offers access to
                world-famous wrecks like the HMS Hermes, along with colorful reefs alive with
                tropical fish. Whale and dolphin sightings are also common offshore, adding extra
                excitement to your dives. With warm waters and excellent visibility, the West Coast
                is perfect for both beginners and advanced divers. From Negombo to Unawatuna, every
                site brings a unique underwater adventure waiting to be discovered.
              </MKTypography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={12}>
            <MKTypography variant="body1" mt={4} mb={0}>
              <strong>
                At our Mount Lavinia & Colombo Dive Sites with different depth from 6 to 30 m we
                offer{" "}
                <span
                  onClick={() => setActiveSection("wreck")}
                  style={{
                    cursor: "pointer",
                    color: activeSection === "wreck" ? "#d32f2f" : "#1976d2",
                    textDecoration: "underline",
                  }}
                >
                  Wreck Dives
                </span>{" "}
                and{" "}
                <span
                  onClick={() => setActiveSection("reef")}
                  style={{
                    cursor: "pointer",
                    color: activeSection === "reef" ? "#d32f2f" : "#1976d2",
                    textDecoration: "underline",
                  }}
                >
                  Reef Dives
                </span>
                .
              </strong>
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
      <Container>
        {activeSection === "wreck" && <Wrecksite />}
        {activeSection === "reef" && <Reefdives />}
      </Container>
    </MKBox>
  );
}

export default Introduction;
